import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from "classnames";
import useTranslations from "@hooks/useTranslations";
export const SearchResultsFilters = (props) => {
    const { t } = useTranslations();
    const { filters, activeFilters, onFilterClick } = props;
    const isFilterActive = (filterValue) => {
        return !!activeFilters && activeFilters.includes(filterValue);
    };
    return (_jsx("div", { className: "search-results__filter-items-container", children: filters.options.map(({ label, value, count }, index) => (_jsxs("div", { className: cn("search-results__filter-item", { "search-results__filter-item--active": isFilterActive(value), "search-results__filter-item--disabled": count === 0 }), onClick: () => onFilterClick([{ name: filters.name, options: [value] }]), children: [_jsx("p", { className: "search-results__filter-item-label", children: t(label) }), _jsxs("p", { className: "search-results__filter-item-count", children: ["(", count, ")"] })] }, `${index}-${value}`))) }));
};
